<mat-form-field class="example-full-width" appearance="outline">
  <mat-label>Клиент</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto"
    [attr.aria-busy]="loading" (keydown)="onInputKeydown($event)" (blur)="cancelPendingEnter()" />
  <button *ngIf="allowClear && control.value" type="button" mat-icon-button matSuffix
    aria-label="Очистить клиента" (click)="control.setValue(null)">
    <mat-icon>close</mat-icon>
  </button>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayProperty"
    [autoActiveFirstOption]="hasClientQuery"
    (optionSelected)="handleSelect($event)"
  >
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    <mat-option *ngIf="loading" disabled>Поиск клиента…</mat-option>
    <mat-option *ngIf="searchFailed" disabled>Не удалось загрузить клиентов</mat-option>
    <mat-option *ngFor="let client of clients" [value]="client">
      <div class="client_wrapper">
        <span class="client_name">{{ client.name || 'Клиент без имени' }}</span>
        <span class="client_phone"><small>№{{ client.id }} · </small>{{ getPhoneSummary(client) }}</span>
      </div>
    </mat-option>
    <mat-option *ngIf="canCreateClient" [value]="control.value">
      Создать {{ control.value }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
